import { Injectable } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class BreadcrumbService {
  private itemsSource = new Subject<MenuItem[]>();
  private visibleSource = new BehaviorSubject<boolean>(true);

  itemsHandler = this.itemsSource.asObservable();
  visibleHandler = this.visibleSource.asObservable();

  setItems(items: MenuItem[]) {
    this.itemsSource.next(items);
  }

  setVisible(visible: boolean) {
    this.visibleSource.next(visible);
  }
}
